import React, { useEffect, useState, useMemo } from "react";
import { Spinner } from "react-bootstrap";

export const PurchasedPrice = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch("/api/purchased-price-summary");
                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const data = await response.json();
                // data уже сгруппировано и отсортировано сервером
                setProducts(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Помилка завантаження даних:", err);
                setError("Сервер недоступний. Спробуйте оновити сторінку.");
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const { money, quantity } = useMemo(
        () =>
            products.reduce(
                (acc, p) => {
                    acc.money += p.purchased_price;
                    acc.quantity += p.quantity;
                    return acc;
                },
                { money: 0, quantity: 0 }
            ),
        [products]
    );

    return (
        <>
            <header style={{ padding: "1rem 0" }}>
                <div className="container">
                    <div className="inner-header" style={{ justifyContent: "start" }}>
                        <h4 style={{ textAlign: "center", marginBottom: 0, marginRight: "auto", textTransform: "uppercase" }}>
                            Склад денег
                        </h4>
                        {products.length !== 0 && (
                            <>
                                <span
                                    style={{
                                        color: "#D72638",
                                        padding: "5px 20px",
                                        backgroundColor: "#fff",
                                        marginRight: "0px",
                                    }}
                                >
                                    {money.toLocaleString()} грн.
                                </span>
                                <span
                                    style={{
                                        color: "#f00",
                                        padding: "5px 20px",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    {quantity.toLocaleString()} шт.
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </header>
            <main style={{ padding: "1rem 0" }}>
                <div className="container">
                    {loading ? (
                        <div style={{ textAlign: "center" }}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : error ? (
                        <div style={{ textAlign: "center", color: "#D72638" }}>
                            <p>{error}</p>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => window.location.reload()}>
                                Оновити сторінку
                            </button>
                        </div>
                    ) : products.length !== 0 ? (
                        <table className="table table-bordered">
                            <tbody>
                                {products.map((p, i) => (
                                    <tr key={p._id ?? i} style={{ textAlign: "left" }}>
                                        <td>{i + 1}</td>
                                        <td>{p.name}</td>
                                        <td>
                                            <span style={{ fontSize: "18px" }}>{p.purchased_price.toLocaleString()}</span> грн.
                                        </td>
                                        <td>{p.quantity} шт.</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div style={{ textAlign: "center" }}>
                            <p>Немає даних для відображення</p>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};
